import React, { useState, useEffect, memo } from 'react';
import Styles from './FinalSaction.module.css';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import FinalSanction from './FinalSanction';
import {
  finalSanctionGETAPI,
  moveToDisbursementAPI
} from '../../../common/constants/api';
import _ from 'lodash';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import PopUp from '../../../common/components/PopUp/PopUp';

import { Formik, Form } from 'formik';
import Valuation from './Valuation/Valuation';
import Legal from './Legal';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import CMRejectLead from '../CMRejectLead/CMRejectLead';

const comonSelectContainerEffect = {
  minHeight: '52px',
  marginBottom: '0px',
  fontSize: '40px',
  alignItems: 'center'
};
const commonDropDownStles = {
  top: '52px',
  color: 'rgba(0,0,0,0.87)',
  fontSize: '16px',
  backgroundColor: '#fff',
  alignItems: 'center',
  fontFamily: 'Roboto',
  fontWeight: 400
};

const selectCommonDisplay = {
  fontSize: '14px',
  padding: '0 25px',
  alignItems: 'center',
  minHeight: '52px'
};

const { scrollbar_none } = Styles;

const updateLeadStatus = async setTriggerStatusUpdate => {
  if (localStorage.hasOwnProperty('applicantionInfo')) {
    let leadInfo = JSON.parse(localStorage.getItem('applicantionInfo'));
    leadInfo.applicationStatus = 'Sanctioned';
    localStorage.setItem('applicantionInfo', JSON.stringify(leadInfo));
    setTriggerStatusUpdate('Sanctioned');
  } else {
    throw new Error('applicationInfo Key word error in local storage');
  }
};
const FinalSactionContainer = ({
  setTriggerStatusUpdate,
  setHighlightedOpt,
  MenuOnclickHandler
}) => {
  const [enableBtn, setEnableBtn] = useState(false);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);

  //get all data
  useEffect(() => {
    finalSanctionGETAPI(getApplicantionInfo().leadId, 'final-sanction')
      .then(res => {
        if (res.finalSanctionDetails && res.sanctionLetterDoc) {
          setEnableBtn(true);
        }
      })
      .catch(err => {});
  }, []);

  async function moveToDisbursementFun() {
    if (enableBtn === true) {
      setType('loading');
      setText('Please Wait...');
      setShow(true);
      await moveToDisbursementAPI(getApplicantionInfo().leadId)
        .then(res => {
          updateLeadStatus(setTriggerStatusUpdate);
          setShow(false);
          setHighlightedOpt(5);
          MenuOnclickHandler(5);
        })
        .catch(err => {
          setShow(false);
        });
    }
  }

  return (
    <React.Fragment>
      <div
        className="md:w-7/12 w-full bg-white my-4 mx-5  border-grey-1009 border rounded bg-blue-1210 pb-5 md:bg-white"
        style={{ minWidth: '21.5rem' }}
      >
        <div className={`w-full flex py-3 px-3`}>
          <Formik
            initialValues={{
              step: { label: 'Final Sanction', value: 'finl_sctn' }
            }}
          >
            {({ setFieldValue, touched, values, errors }) => (
              <Form className={`w-full`}>
                <div className="">
                  <TopButtonBar
                    setFieldValue={setFieldValue}
                    touched={touched}
                    values={values}
                    errors={errors}
                    moveToDisbursementFun={moveToDisbursementFun}
                    enableBtn={enableBtn}
                  />
                </div>
                <div className="">
                  {values.step.value == 'valuation' ? <Valuation /> : null}
                  {values.step.value === 'finl_sctn' ? (
                    <FinalSanction setEnableBtn={setEnableBtn} />
                  ) : null}
                  {values.step.value === 'legal' ? <Legal /> : null}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <PopUp type={type} text={text} setShow={setShow} show={show} />
    </React.Fragment>
  );
};
export default memo(withErrorHandler(FinalSactionContainer));

const TopButtonBar = ({
  setFieldValue,
  touched,
  values,
  errors,
  moveToDisbursementFun,
  enableBtn
}) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const commonStyle = {
    width: '5rem',
    marginLeft: '5px',
    marginRight: '5px',
    padding: '10px',
    textAlign: 'center',
    borderRadius: '5px',
    display: 'block',
    border: 'none',
    minWidth: '100px'
  };
  const btn_selected = {
    backgroundColor: 'rgb(255 219 181)',
    color: '#FF8000'
  };
  const btn_not_selected = {
    backgroundColor: 'white',
    color: 'rgb(255 206 157)'
  };
  const buttonList = [
    {
      label: 'Final Sanction',
      value: 'finl_sctn'
    },
    {
      label: 'Legal',
      value: 'legal'
    },
    {
      label: 'Valuation',
      value: 'valuation'
    }
  ];

  const isValidToShow = () => {
    if (!localStorage.hasOwnProperty('applicantionInfo')) return true;
    let leadData = JSON.parse(localStorage.getItem('applicantionInfo'));
    if (
      leadData?.applicationStatus != 'Disbursed' &&
      leadData?.applicationStatus != 'Sanctioned'
    )
      return true;
    return false;
  };
  const HtmlTooltip = withStyles(theme => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9'
    }
  }))(Tooltip);

  const RejectLeadBlock = () => {
    return (
      <div className="w-full ml-auto text-right px-2">
        <HtmlTooltip
          title={
            <div>
              <p className="font-roboto font-normal text-balck-500 text-xs ">
                You can again Login the lead to other bank after rejection.
              </p>
            </div>
          }
        >
          <Button
            onClick={() => setShowRejectModal(true)}
            variant="outlined"
            color="secondary"
            className="font-roboto font-light  px-4 ml-auto rounded cursor-pointer  normal-case "
            style={{ minWidth: '120px' }}
          >
            Reject Lead
          </Button>
        </HtmlTooltip>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className={`w-full flex py-3 px-3`}>
        <div
          className={`w-full md:flex hidden overflow-auto ${scrollbar_none}`}
        >
          {buttonList.map((each, index) => (
            <button
              name="step"
              key={index}
              type="button"
              onClick={() => {
                setFieldValue('step', {
                  value: each.value,
                  label: each.label
                });
              }}
              style={Object.assign(
                {},
                commonStyle,
                values.step.value == each.value
                  ? btn_selected
                  : btn_not_selected
              )}
              className={`mr-1  flex border border-green-600 text-green-600  font-roboto font-normal rounded font-medium text-xs`}
            >
              {each.label}
            </button>
          ))}
          {['Sanctioned', 'Disbursed'].includes(
            getApplicantionInfo()?.applicationStatus
          ) && <RejectLeadBlock />}
          {isValidToShow() ? (
            <button
              onClick={() => {
                moveToDisbursementFun();
              }}
              name="add_to_dsbrsment"
              type="button"
              disabled={enableBtn ? false : true}
              style={Object.assign({}, commonStyle, {
                backgroundColor: enableBtn ? '#00ACB8' : '#CBCBCB',
                color: 'white',
                width: '12rem',
                marginLeft: 'auto',
                minWidth: '150px'
              })}
              className={`mr-1  flex border border-green-600 text-green-600  font-roboto font-normal rounded font-medium text-xs float-right ml-10`}
            >
              Move to Disbursement
            </button>
          ) : null}
        </div>
        <div className="w-full md:hidden block ">
          <div className="table mr-auto mb-2 -ml-1">
            {['Sanctioned', 'Disbursed'].includes(
              getApplicantionInfo()?.applicationStatus
            ) && <RejectLeadBlock />}
          </div>

          <CommonSelect sort={true}
            name="step"
            value={values.step}
            onChange={e => {
              setFieldValue('step', {
                value: e.value,
                label: e.label
              });
            }}
            options={buttonList}
            isHoverEffect
            stylesContainer={comonSelectContainerEffect}
            dropdownStyle={commonDropDownStles}
            styleText={selectCommonDisplay}
            error={touched.step && _.get(errors, 'step.value', false)}
            touched={touched.step}
          />
        </div>
      </div>
      <CMRejectLead show={showRejectModal} setShow={setShowRejectModal} />
    </React.Fragment>
  );
};
